<template>
    <div>
        <slot :months="months" :opendialog="opendialog"></slot>
    </div>
</template>

<script>
import { groupBy, map } from 'lodash';
import { format, isSameYear } from 'date-fns';
import { ref, defineComponent, watch } from 'vue';

export default defineComponent({
    name: 'CalendarList',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        opendialog: {
            type: Function,
            required: true,
        }
    },
    setup(props) {
        const months = ref([]);
        const openDialog = ref(null);

        // const featuredBlocks = ref([]);
        // const FEATURE_BLOCK = 'featured-highlight';


        // const setupFeaturedBlocks = (blocks) => {
        //     console.log('BLOCKS: ', blocks);
        //     const groupedFeatures = groupBy(blocks, block => block.blockType);
        //     featuredBlocks.value = groupedFeatures[FEATURE_BLOCK];
        // }

        // const showFeature = (index) => {
        //     if (index === 1) {
        //         return true;
        //     }
        //     return false;
        // }

        const computeMonths = (items) => {
            if (!items.length) return;

            const groupedDays = groupBy(items, item => item._auxiliary.group_by_day);

            const processedDays = map(groupedDays, (items, key) => ({
                id: `day-${key}`,
                day: format(items[0].performancedate, 'EEE'),
                date: format(items[0].performancedate, 'd'),
                events: items,
                _auxiliary: items[0]._auxiliary,
            }));

            const groupedMonths = groupBy(processedDays, item => item._auxiliary.group_by_month);

            months.value = map(groupedMonths, (items, key) => ({
                id: `month-${key}`,
                title: items[0]._auxiliary.group_name_month,
                days: items,
            }));
        };

        watch(
            [() => props.items, () => props.opendialog],
            ([newItems, newOpenDialog]) => {
                computeMonths(newItems);
                openDialog.value = newOpenDialog;

                //setupFeaturedBlocks(newBlocks);
            },
            { immediate: true }
        );

        return {
            months,
            opendialog: openDialog,
        };
    },
});
</script>
